import { render, staticRenderFns } from "./AssignOrdersOutForDelivery.vue?vue&type=template&id=53e218bd&scoped=true&"
import script from "./AssignOrdersOutForDelivery.vue?vue&type=script&lang=js&"
export * from "./AssignOrdersOutForDelivery.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrdersOutForDelivery.vue?vue&type=style&index=0&id=53e218bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e218bd",
  null
  
)

export default component.exports